if (!customElements.get('and-gift-module')) {
  customElements.define('and-gift-module', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort(); this.lifecycle = new AbortController();
      this.motionMedia = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.visibility?.disconnect();
      const updateMotion = () => {
        const enabled = this.inView && !document.hidden && !this.motionMedia.matches && !navigator.connection?.saveData && !this.classList.contains('ag-no-motion') && !this.classList.contains('ag-occasion-none');
        this.classList.toggle('ag-motion-active', enabled);
      };
      this.updateMotion = updateMotion;
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; updateMotion(); }, { rootMargin: '0px', threshold: 0 });
        this.visibility.observe(this);
      } else { this.inView = true; }
      document.addEventListener('visibilitychange', updateMotion, { signal: this.lifecycle.signal });
      this.motionMedia.addEventListener?.('change', updateMotion, { signal: this.lifecycle.signal });
      navigator.connection?.addEventListener?.('change', updateMotion, { signal: this.lifecycle.signal });
      updateMotion();
      this.headings = [...this.querySelectorAll('.ag-header h3')];
      this.resize = new ResizeObserver(() => this.fit());
      this.resize.observe(this);
      this.fit();
      document.fonts?.ready.then(() => { if (this.isConnected) this.fit(); });
    }
    disconnectedCallback() { this.resize?.disconnect(); this.visibility?.disconnect(); this.lifecycle?.abort(); this.classList.remove('ag-motion-active'); }
    fit() {
      for (const heading of this.querySelectorAll('.ag-header h3')) {
        heading.style.fontSize = '';
        const maximum = parseFloat(getComputedStyle(heading).fontSize);
        heading.style.whiteSpace = 'nowrap';
        let size = maximum;
        while (heading.scrollWidth > heading.clientWidth + 1 && size > 12) {
          size = Math.max(12, size - 0.25);
          heading.style.fontSize = size + 'px';
        }
        if (heading.scrollWidth > heading.clientWidth + 1) heading.style.whiteSpace = 'normal';
      }
    }
  });
}

